import React from 'react';

const Footer = () => (
  <div className="mt-24">
    <p className="dark:text-gray-200 text-gray-700 text-center text-xs m-20">
      © 2025 Todos los derechos reservados por aulanovus Spa [v2.2.01]
    </p>
  </div>
);

export default Footer;